/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as WorkOrdersRouteRouteImport } from './routes/work-orders/route'
import { Route as MeRouteRouteImport } from './routes/me/route'
import { Route as BigRentzLiftsRouteRouteImport } from './routes/big-rentz-lifts/route'
import { Route as AssetsRouteRouteImport } from './routes/assets/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkOrdersIndexRouteImport } from './routes/work-orders/index'
import { Route as DataIndexRouteImport } from './routes/data/index'
import { Route as BigRentzLiftsIndexRouteImport } from './routes/big-rentz-lifts/index'
import { Route as AssetsIndexRouteImport } from './routes/assets/index'
import { Route as WorkOrdersCreateWorkOrderRouteImport } from './routes/work-orders/create-work-order'
import { Route as NotificationActionRouteImport } from './routes/notification/action'
import { Route as DataProjectsRouteImport } from './routes/data/projects'
import { Route as DataCreateLocationsRouteImport } from './routes/data/create-locations'
import { Route as DataClientsRouteImport } from './routes/data/clients'
import { Route as AuthUnauthorizedRouteImport } from './routes/auth/unauthorized'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AssetsAddShipmentRouteImport } from './routes/assets/add-shipment'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminMetadataRouteImport } from './routes/admin/metadata'
import { Route as AdminGroupsRouteImport } from './routes/admin/groups'
import { Route as AdminDevDataRouteImport } from './routes/admin/dev-data'
import { Route as AdminBulkUploadRouteImport } from './routes/admin/bulk-upload'
import { Route as AdminAuditSignalsRouteImport } from './routes/admin/audit-signals'
import { Route as AdminApiKeysRouteImport } from './routes/admin/api-keys'
import { Route as DataTemplatesRouteRouteImport } from './routes/data/templates/route'
import { Route as WorkOrdersCreateIndexRouteImport } from './routes/work-orders/create/index'
import { Route as FinanceSalesOrdersIndexRouteImport } from './routes/finance/sales-orders/index'
import { Route as FieldServicesSupportCasesIndexRouteImport } from './routes/field-services/support-cases/index'
import { Route as DataLocationsIndexRouteImport } from './routes/data/locations/index'
import { Route as WorkOrdersCreateBatchIdRouteImport } from './routes/work-orders/create/$batchId'
import { Route as MeNotificationsPreferencesRouteImport } from './routes/me/notifications/preferences'
import { Route as MeNotificationsManagedRouteImport } from './routes/me/notifications/managed'
import { Route as MeNotificationsAllRouteImport } from './routes/me/notifications/all'
import { Route as DataTemplatesTemplateIdRouteImport } from './routes/data/templates/$templateId'
import { Route as AdminGeneralWebhooksRouteImport } from './routes/admin/general/webhooks'
import { Route as AdminGeneralCronJobsRouteImport } from './routes/admin/general/cron-jobs'
import { Route as AdminGeneralBannerRouteImport } from './routes/admin/general/banner'
import { Route as AdminGeneralAlertDiagnosticsRouteImport } from './routes/admin/general/alert-diagnostics'
import { Route as DataLocationsCreateIndexRouteImport } from './routes/data/locations/create/index'
import { Route as DataLocationsCreateBatchIdRouteImport } from './routes/data/locations/create/$batchId'

const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersRouteRoute = WorkOrdersRouteRouteImport.update({
  id: '/work-orders',
  path: '/work-orders',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRouteRoute = MeRouteRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const BigRentzLiftsRouteRoute = BigRentzLiftsRouteRouteImport.update({
  id: '/big-rentz-lifts',
  path: '/big-rentz-lifts',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsRouteRoute = AssetsRouteRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersIndexRoute = WorkOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkOrdersRouteRoute,
} as any)
const DataIndexRoute = DataIndexRouteImport.update({
  id: '/data/',
  path: '/data/',
  getParentRoute: () => rootRouteImport,
} as any)
const BigRentzLiftsIndexRoute = BigRentzLiftsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BigRentzLiftsRouteRoute,
} as any)
const AssetsIndexRoute = AssetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AssetsRouteRoute,
} as any)
const WorkOrdersCreateWorkOrderRoute =
  WorkOrdersCreateWorkOrderRouteImport.update({
    id: '/create-work-order',
    path: '/create-work-order',
    getParentRoute: () => WorkOrdersRouteRoute,
  } as any)
const NotificationActionRoute = NotificationActionRouteImport.update({
  id: '/notification/action',
  path: '/notification/action',
  getParentRoute: () => rootRouteImport,
} as any)
const DataProjectsRoute = DataProjectsRouteImport.update({
  id: '/data/projects',
  path: '/data/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const DataCreateLocationsRoute = DataCreateLocationsRouteImport.update({
  id: '/data/create-locations',
  path: '/data/create-locations',
  getParentRoute: () => rootRouteImport,
} as any)
const DataClientsRoute = DataClientsRouteImport.update({
  id: '/data/clients',
  path: '/data/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUnauthorizedRoute = AuthUnauthorizedRouteImport.update({
  id: '/auth/unauthorized',
  path: '/auth/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsAddShipmentRoute = AssetsAddShipmentRouteImport.update({
  id: '/add-shipment',
  path: '/add-shipment',
  getParentRoute: () => AssetsRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMetadataRoute = AdminMetadataRouteImport.update({
  id: '/metadata',
  path: '/metadata',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGroupsRoute = AdminGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDevDataRoute = AdminDevDataRouteImport.update({
  id: '/dev-data',
  path: '/dev-data',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBulkUploadRoute = AdminBulkUploadRouteImport.update({
  id: '/bulk-upload',
  path: '/bulk-upload',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditSignalsRoute = AdminAuditSignalsRouteImport.update({
  id: '/audit-signals',
  path: '/audit-signals',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminApiKeysRoute = AdminApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AdminRouteRoute,
} as any)
const DataTemplatesRouteRoute = DataTemplatesRouteRouteImport.update({
  id: '/data/templates',
  path: '/data/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersCreateIndexRoute = WorkOrdersCreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => WorkOrdersRouteRoute,
} as any)
const FinanceSalesOrdersIndexRoute = FinanceSalesOrdersIndexRouteImport.update({
  id: '/finance/sales-orders/',
  path: '/finance/sales-orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const FieldServicesSupportCasesIndexRoute =
  FieldServicesSupportCasesIndexRouteImport.update({
    id: '/field-services/support-cases/',
    path: '/field-services/support-cases/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DataLocationsIndexRoute = DataLocationsIndexRouteImport.update({
  id: '/data/locations/',
  path: '/data/locations/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersCreateBatchIdRoute = WorkOrdersCreateBatchIdRouteImport.update({
  id: '/create/$batchId',
  path: '/create/$batchId',
  getParentRoute: () => WorkOrdersRouteRoute,
} as any)
const MeNotificationsPreferencesRoute =
  MeNotificationsPreferencesRouteImport.update({
    id: '/notifications/preferences',
    path: '/notifications/preferences',
    getParentRoute: () => MeRouteRoute,
  } as any)
const MeNotificationsManagedRoute = MeNotificationsManagedRouteImport.update({
  id: '/notifications/managed',
  path: '/notifications/managed',
  getParentRoute: () => MeRouteRoute,
} as any)
const MeNotificationsAllRoute = MeNotificationsAllRouteImport.update({
  id: '/notifications/all',
  path: '/notifications/all',
  getParentRoute: () => MeRouteRoute,
} as any)
const DataTemplatesTemplateIdRoute = DataTemplatesTemplateIdRouteImport.update({
  id: '/$templateId',
  path: '/$templateId',
  getParentRoute: () => DataTemplatesRouteRoute,
} as any)
const AdminGeneralWebhooksRoute = AdminGeneralWebhooksRouteImport.update({
  id: '/general/webhooks',
  path: '/general/webhooks',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGeneralCronJobsRoute = AdminGeneralCronJobsRouteImport.update({
  id: '/general/cron-jobs',
  path: '/general/cron-jobs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGeneralBannerRoute = AdminGeneralBannerRouteImport.update({
  id: '/general/banner',
  path: '/general/banner',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGeneralAlertDiagnosticsRoute =
  AdminGeneralAlertDiagnosticsRouteImport.update({
    id: '/general/alert-diagnostics',
    path: '/general/alert-diagnostics',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const DataLocationsCreateIndexRoute =
  DataLocationsCreateIndexRouteImport.update({
    id: '/data/locations/create/',
    path: '/data/locations/create/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DataLocationsCreateBatchIdRoute =
  DataLocationsCreateBatchIdRouteImport.update({
    id: '/data/locations/create/$batchId',
    path: '/data/locations/create/$batchId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/assets': typeof AssetsRouteRouteWithChildren
  '/big-rentz-lifts': typeof BigRentzLiftsRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/work-orders': typeof WorkOrdersRouteRouteWithChildren
  '/test': typeof TestRoute
  '/data/templates': typeof DataTemplatesRouteRouteWithChildren
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit-signals': typeof AdminAuditSignalsRoute
  '/admin/bulk-upload': typeof AdminBulkUploadRoute
  '/admin/dev-data': typeof AdminDevDataRoute
  '/admin/groups': typeof AdminGroupsRoute
  '/admin/metadata': typeof AdminMetadataRoute
  '/admin/users': typeof AdminUsersRoute
  '/assets/add-shipment': typeof AssetsAddShipmentRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/unauthorized': typeof AuthUnauthorizedRoute
  '/data/clients': typeof DataClientsRoute
  '/data/create-locations': typeof DataCreateLocationsRoute
  '/data/projects': typeof DataProjectsRoute
  '/notification/action': typeof NotificationActionRoute
  '/work-orders/create-work-order': typeof WorkOrdersCreateWorkOrderRoute
  '/assets/': typeof AssetsIndexRoute
  '/big-rentz-lifts/': typeof BigRentzLiftsIndexRoute
  '/data/': typeof DataIndexRoute
  '/work-orders/': typeof WorkOrdersIndexRoute
  '/admin/general/alert-diagnostics': typeof AdminGeneralAlertDiagnosticsRoute
  '/admin/general/banner': typeof AdminGeneralBannerRoute
  '/admin/general/cron-jobs': typeof AdminGeneralCronJobsRoute
  '/admin/general/webhooks': typeof AdminGeneralWebhooksRoute
  '/data/templates/$templateId': typeof DataTemplatesTemplateIdRoute
  '/me/notifications/all': typeof MeNotificationsAllRoute
  '/me/notifications/managed': typeof MeNotificationsManagedRoute
  '/me/notifications/preferences': typeof MeNotificationsPreferencesRoute
  '/work-orders/create/$batchId': typeof WorkOrdersCreateBatchIdRoute
  '/data/locations/': typeof DataLocationsIndexRoute
  '/field-services/support-cases/': typeof FieldServicesSupportCasesIndexRoute
  '/finance/sales-orders/': typeof FinanceSalesOrdersIndexRoute
  '/work-orders/create/': typeof WorkOrdersCreateIndexRoute
  '/data/locations/create/$batchId': typeof DataLocationsCreateBatchIdRoute
  '/data/locations/create/': typeof DataLocationsCreateIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/test': typeof TestRoute
  '/data/templates': typeof DataTemplatesRouteRouteWithChildren
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit-signals': typeof AdminAuditSignalsRoute
  '/admin/bulk-upload': typeof AdminBulkUploadRoute
  '/admin/dev-data': typeof AdminDevDataRoute
  '/admin/groups': typeof AdminGroupsRoute
  '/admin/metadata': typeof AdminMetadataRoute
  '/admin/users': typeof AdminUsersRoute
  '/assets/add-shipment': typeof AssetsAddShipmentRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/unauthorized': typeof AuthUnauthorizedRoute
  '/data/clients': typeof DataClientsRoute
  '/data/create-locations': typeof DataCreateLocationsRoute
  '/data/projects': typeof DataProjectsRoute
  '/notification/action': typeof NotificationActionRoute
  '/work-orders/create-work-order': typeof WorkOrdersCreateWorkOrderRoute
  '/assets': typeof AssetsIndexRoute
  '/big-rentz-lifts': typeof BigRentzLiftsIndexRoute
  '/data': typeof DataIndexRoute
  '/work-orders': typeof WorkOrdersIndexRoute
  '/admin/general/alert-diagnostics': typeof AdminGeneralAlertDiagnosticsRoute
  '/admin/general/banner': typeof AdminGeneralBannerRoute
  '/admin/general/cron-jobs': typeof AdminGeneralCronJobsRoute
  '/admin/general/webhooks': typeof AdminGeneralWebhooksRoute
  '/data/templates/$templateId': typeof DataTemplatesTemplateIdRoute
  '/me/notifications/all': typeof MeNotificationsAllRoute
  '/me/notifications/managed': typeof MeNotificationsManagedRoute
  '/me/notifications/preferences': typeof MeNotificationsPreferencesRoute
  '/work-orders/create/$batchId': typeof WorkOrdersCreateBatchIdRoute
  '/data/locations': typeof DataLocationsIndexRoute
  '/field-services/support-cases': typeof FieldServicesSupportCasesIndexRoute
  '/finance/sales-orders': typeof FinanceSalesOrdersIndexRoute
  '/work-orders/create': typeof WorkOrdersCreateIndexRoute
  '/data/locations/create/$batchId': typeof DataLocationsCreateBatchIdRoute
  '/data/locations/create': typeof DataLocationsCreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/assets': typeof AssetsRouteRouteWithChildren
  '/big-rentz-lifts': typeof BigRentzLiftsRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/work-orders': typeof WorkOrdersRouteRouteWithChildren
  '/test': typeof TestRoute
  '/data/templates': typeof DataTemplatesRouteRouteWithChildren
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit-signals': typeof AdminAuditSignalsRoute
  '/admin/bulk-upload': typeof AdminBulkUploadRoute
  '/admin/dev-data': typeof AdminDevDataRoute
  '/admin/groups': typeof AdminGroupsRoute
  '/admin/metadata': typeof AdminMetadataRoute
  '/admin/users': typeof AdminUsersRoute
  '/assets/add-shipment': typeof AssetsAddShipmentRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/unauthorized': typeof AuthUnauthorizedRoute
  '/data/clients': typeof DataClientsRoute
  '/data/create-locations': typeof DataCreateLocationsRoute
  '/data/projects': typeof DataProjectsRoute
  '/notification/action': typeof NotificationActionRoute
  '/work-orders/create-work-order': typeof WorkOrdersCreateWorkOrderRoute
  '/assets/': typeof AssetsIndexRoute
  '/big-rentz-lifts/': typeof BigRentzLiftsIndexRoute
  '/data/': typeof DataIndexRoute
  '/work-orders/': typeof WorkOrdersIndexRoute
  '/admin/general/alert-diagnostics': typeof AdminGeneralAlertDiagnosticsRoute
  '/admin/general/banner': typeof AdminGeneralBannerRoute
  '/admin/general/cron-jobs': typeof AdminGeneralCronJobsRoute
  '/admin/general/webhooks': typeof AdminGeneralWebhooksRoute
  '/data/templates/$templateId': typeof DataTemplatesTemplateIdRoute
  '/me/notifications/all': typeof MeNotificationsAllRoute
  '/me/notifications/managed': typeof MeNotificationsManagedRoute
  '/me/notifications/preferences': typeof MeNotificationsPreferencesRoute
  '/work-orders/create/$batchId': typeof WorkOrdersCreateBatchIdRoute
  '/data/locations/': typeof DataLocationsIndexRoute
  '/field-services/support-cases/': typeof FieldServicesSupportCasesIndexRoute
  '/finance/sales-orders/': typeof FinanceSalesOrdersIndexRoute
  '/work-orders/create/': typeof WorkOrdersCreateIndexRoute
  '/data/locations/create/$batchId': typeof DataLocationsCreateBatchIdRoute
  '/data/locations/create/': typeof DataLocationsCreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/assets'
    | '/big-rentz-lifts'
    | '/me'
    | '/work-orders'
    | '/test'
    | '/data/templates'
    | '/admin/api-keys'
    | '/admin/audit-signals'
    | '/admin/bulk-upload'
    | '/admin/dev-data'
    | '/admin/groups'
    | '/admin/metadata'
    | '/admin/users'
    | '/assets/add-shipment'
    | '/auth/login'
    | '/auth/unauthorized'
    | '/data/clients'
    | '/data/create-locations'
    | '/data/projects'
    | '/notification/action'
    | '/work-orders/create-work-order'
    | '/assets/'
    | '/big-rentz-lifts/'
    | '/data/'
    | '/work-orders/'
    | '/admin/general/alert-diagnostics'
    | '/admin/general/banner'
    | '/admin/general/cron-jobs'
    | '/admin/general/webhooks'
    | '/data/templates/$templateId'
    | '/me/notifications/all'
    | '/me/notifications/managed'
    | '/me/notifications/preferences'
    | '/work-orders/create/$batchId'
    | '/data/locations/'
    | '/field-services/support-cases/'
    | '/finance/sales-orders/'
    | '/work-orders/create/'
    | '/data/locations/create/$batchId'
    | '/data/locations/create/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/me'
    | '/test'
    | '/data/templates'
    | '/admin/api-keys'
    | '/admin/audit-signals'
    | '/admin/bulk-upload'
    | '/admin/dev-data'
    | '/admin/groups'
    | '/admin/metadata'
    | '/admin/users'
    | '/assets/add-shipment'
    | '/auth/login'
    | '/auth/unauthorized'
    | '/data/clients'
    | '/data/create-locations'
    | '/data/projects'
    | '/notification/action'
    | '/work-orders/create-work-order'
    | '/assets'
    | '/big-rentz-lifts'
    | '/data'
    | '/work-orders'
    | '/admin/general/alert-diagnostics'
    | '/admin/general/banner'
    | '/admin/general/cron-jobs'
    | '/admin/general/webhooks'
    | '/data/templates/$templateId'
    | '/me/notifications/all'
    | '/me/notifications/managed'
    | '/me/notifications/preferences'
    | '/work-orders/create/$batchId'
    | '/data/locations'
    | '/field-services/support-cases'
    | '/finance/sales-orders'
    | '/work-orders/create'
    | '/data/locations/create/$batchId'
    | '/data/locations/create'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/assets'
    | '/big-rentz-lifts'
    | '/me'
    | '/work-orders'
    | '/test'
    | '/data/templates'
    | '/admin/api-keys'
    | '/admin/audit-signals'
    | '/admin/bulk-upload'
    | '/admin/dev-data'
    | '/admin/groups'
    | '/admin/metadata'
    | '/admin/users'
    | '/assets/add-shipment'
    | '/auth/login'
    | '/auth/unauthorized'
    | '/data/clients'
    | '/data/create-locations'
    | '/data/projects'
    | '/notification/action'
    | '/work-orders/create-work-order'
    | '/assets/'
    | '/big-rentz-lifts/'
    | '/data/'
    | '/work-orders/'
    | '/admin/general/alert-diagnostics'
    | '/admin/general/banner'
    | '/admin/general/cron-jobs'
    | '/admin/general/webhooks'
    | '/data/templates/$templateId'
    | '/me/notifications/all'
    | '/me/notifications/managed'
    | '/me/notifications/preferences'
    | '/work-orders/create/$batchId'
    | '/data/locations/'
    | '/field-services/support-cases/'
    | '/finance/sales-orders/'
    | '/work-orders/create/'
    | '/data/locations/create/$batchId'
    | '/data/locations/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AssetsRouteRoute: typeof AssetsRouteRouteWithChildren
  BigRentzLiftsRouteRoute: typeof BigRentzLiftsRouteRouteWithChildren
  MeRouteRoute: typeof MeRouteRouteWithChildren
  WorkOrdersRouteRoute: typeof WorkOrdersRouteRouteWithChildren
  TestRoute: typeof TestRoute
  DataTemplatesRouteRoute: typeof DataTemplatesRouteRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
  AuthUnauthorizedRoute: typeof AuthUnauthorizedRoute
  DataClientsRoute: typeof DataClientsRoute
  DataCreateLocationsRoute: typeof DataCreateLocationsRoute
  DataProjectsRoute: typeof DataProjectsRoute
  NotificationActionRoute: typeof NotificationActionRoute
  DataIndexRoute: typeof DataIndexRoute
  DataLocationsIndexRoute: typeof DataLocationsIndexRoute
  FieldServicesSupportCasesIndexRoute: typeof FieldServicesSupportCasesIndexRoute
  FinanceSalesOrdersIndexRoute: typeof FinanceSalesOrdersIndexRoute
  DataLocationsCreateBatchIdRoute: typeof DataLocationsCreateBatchIdRoute
  DataLocationsCreateIndexRoute: typeof DataLocationsCreateIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders': {
      id: '/work-orders'
      path: '/work-orders'
      fullPath: '/work-orders'
      preLoaderRoute: typeof WorkOrdersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/big-rentz-lifts': {
      id: '/big-rentz-lifts'
      path: '/big-rentz-lifts'
      fullPath: '/big-rentz-lifts'
      preLoaderRoute: typeof BigRentzLiftsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets': {
      id: '/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AssetsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/': {
      id: '/work-orders/'
      path: '/'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof WorkOrdersIndexRouteImport
      parentRoute: typeof WorkOrdersRouteRoute
    }
    '/data/': {
      id: '/data/'
      path: '/data'
      fullPath: '/data/'
      preLoaderRoute: typeof DataIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/big-rentz-lifts/': {
      id: '/big-rentz-lifts/'
      path: '/'
      fullPath: '/big-rentz-lifts/'
      preLoaderRoute: typeof BigRentzLiftsIndexRouteImport
      parentRoute: typeof BigRentzLiftsRouteRoute
    }
    '/assets/': {
      id: '/assets/'
      path: '/'
      fullPath: '/assets/'
      preLoaderRoute: typeof AssetsIndexRouteImport
      parentRoute: typeof AssetsRouteRoute
    }
    '/work-orders/create-work-order': {
      id: '/work-orders/create-work-order'
      path: '/create-work-order'
      fullPath: '/work-orders/create-work-order'
      preLoaderRoute: typeof WorkOrdersCreateWorkOrderRouteImport
      parentRoute: typeof WorkOrdersRouteRoute
    }
    '/notification/action': {
      id: '/notification/action'
      path: '/notification/action'
      fullPath: '/notification/action'
      preLoaderRoute: typeof NotificationActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/projects': {
      id: '/data/projects'
      path: '/data/projects'
      fullPath: '/data/projects'
      preLoaderRoute: typeof DataProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/create-locations': {
      id: '/data/create-locations'
      path: '/data/create-locations'
      fullPath: '/data/create-locations'
      preLoaderRoute: typeof DataCreateLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/clients': {
      id: '/data/clients'
      path: '/data/clients'
      fullPath: '/data/clients'
      preLoaderRoute: typeof DataClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/unauthorized': {
      id: '/auth/unauthorized'
      path: '/auth/unauthorized'
      fullPath: '/auth/unauthorized'
      preLoaderRoute: typeof AuthUnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/add-shipment': {
      id: '/assets/add-shipment'
      path: '/add-shipment'
      fullPath: '/assets/add-shipment'
      preLoaderRoute: typeof AssetsAddShipmentRouteImport
      parentRoute: typeof AssetsRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/metadata': {
      id: '/admin/metadata'
      path: '/metadata'
      fullPath: '/admin/metadata'
      preLoaderRoute: typeof AdminMetadataRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/groups': {
      id: '/admin/groups'
      path: '/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof AdminGroupsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/dev-data': {
      id: '/admin/dev-data'
      path: '/dev-data'
      fullPath: '/admin/dev-data'
      preLoaderRoute: typeof AdminDevDataRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bulk-upload': {
      id: '/admin/bulk-upload'
      path: '/bulk-upload'
      fullPath: '/admin/bulk-upload'
      preLoaderRoute: typeof AdminBulkUploadRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit-signals': {
      id: '/admin/audit-signals'
      path: '/audit-signals'
      fullPath: '/admin/audit-signals'
      preLoaderRoute: typeof AdminAuditSignalsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/api-keys': {
      id: '/admin/api-keys'
      path: '/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AdminApiKeysRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/data/templates': {
      id: '/data/templates'
      path: '/data/templates'
      fullPath: '/data/templates'
      preLoaderRoute: typeof DataTemplatesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/create/': {
      id: '/work-orders/create/'
      path: '/create'
      fullPath: '/work-orders/create/'
      preLoaderRoute: typeof WorkOrdersCreateIndexRouteImport
      parentRoute: typeof WorkOrdersRouteRoute
    }
    '/finance/sales-orders/': {
      id: '/finance/sales-orders/'
      path: '/finance/sales-orders'
      fullPath: '/finance/sales-orders/'
      preLoaderRoute: typeof FinanceSalesOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/field-services/support-cases/': {
      id: '/field-services/support-cases/'
      path: '/field-services/support-cases'
      fullPath: '/field-services/support-cases/'
      preLoaderRoute: typeof FieldServicesSupportCasesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/locations/': {
      id: '/data/locations/'
      path: '/data/locations'
      fullPath: '/data/locations/'
      preLoaderRoute: typeof DataLocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/create/$batchId': {
      id: '/work-orders/create/$batchId'
      path: '/create/$batchId'
      fullPath: '/work-orders/create/$batchId'
      preLoaderRoute: typeof WorkOrdersCreateBatchIdRouteImport
      parentRoute: typeof WorkOrdersRouteRoute
    }
    '/me/notifications/preferences': {
      id: '/me/notifications/preferences'
      path: '/notifications/preferences'
      fullPath: '/me/notifications/preferences'
      preLoaderRoute: typeof MeNotificationsPreferencesRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/me/notifications/managed': {
      id: '/me/notifications/managed'
      path: '/notifications/managed'
      fullPath: '/me/notifications/managed'
      preLoaderRoute: typeof MeNotificationsManagedRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/me/notifications/all': {
      id: '/me/notifications/all'
      path: '/notifications/all'
      fullPath: '/me/notifications/all'
      preLoaderRoute: typeof MeNotificationsAllRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/data/templates/$templateId': {
      id: '/data/templates/$templateId'
      path: '/$templateId'
      fullPath: '/data/templates/$templateId'
      preLoaderRoute: typeof DataTemplatesTemplateIdRouteImport
      parentRoute: typeof DataTemplatesRouteRoute
    }
    '/admin/general/webhooks': {
      id: '/admin/general/webhooks'
      path: '/general/webhooks'
      fullPath: '/admin/general/webhooks'
      preLoaderRoute: typeof AdminGeneralWebhooksRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/general/cron-jobs': {
      id: '/admin/general/cron-jobs'
      path: '/general/cron-jobs'
      fullPath: '/admin/general/cron-jobs'
      preLoaderRoute: typeof AdminGeneralCronJobsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/general/banner': {
      id: '/admin/general/banner'
      path: '/general/banner'
      fullPath: '/admin/general/banner'
      preLoaderRoute: typeof AdminGeneralBannerRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/general/alert-diagnostics': {
      id: '/admin/general/alert-diagnostics'
      path: '/general/alert-diagnostics'
      fullPath: '/admin/general/alert-diagnostics'
      preLoaderRoute: typeof AdminGeneralAlertDiagnosticsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/data/locations/create/': {
      id: '/data/locations/create/'
      path: '/data/locations/create'
      fullPath: '/data/locations/create/'
      preLoaderRoute: typeof DataLocationsCreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/locations/create/$batchId': {
      id: '/data/locations/create/$batchId'
      path: '/data/locations/create/$batchId'
      fullPath: '/data/locations/create/$batchId'
      preLoaderRoute: typeof DataLocationsCreateBatchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminApiKeysRoute: typeof AdminApiKeysRoute
  AdminAuditSignalsRoute: typeof AdminAuditSignalsRoute
  AdminBulkUploadRoute: typeof AdminBulkUploadRoute
  AdminDevDataRoute: typeof AdminDevDataRoute
  AdminGroupsRoute: typeof AdminGroupsRoute
  AdminMetadataRoute: typeof AdminMetadataRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminGeneralAlertDiagnosticsRoute: typeof AdminGeneralAlertDiagnosticsRoute
  AdminGeneralBannerRoute: typeof AdminGeneralBannerRoute
  AdminGeneralCronJobsRoute: typeof AdminGeneralCronJobsRoute
  AdminGeneralWebhooksRoute: typeof AdminGeneralWebhooksRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminApiKeysRoute: AdminApiKeysRoute,
  AdminAuditSignalsRoute: AdminAuditSignalsRoute,
  AdminBulkUploadRoute: AdminBulkUploadRoute,
  AdminDevDataRoute: AdminDevDataRoute,
  AdminGroupsRoute: AdminGroupsRoute,
  AdminMetadataRoute: AdminMetadataRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminGeneralAlertDiagnosticsRoute: AdminGeneralAlertDiagnosticsRoute,
  AdminGeneralBannerRoute: AdminGeneralBannerRoute,
  AdminGeneralCronJobsRoute: AdminGeneralCronJobsRoute,
  AdminGeneralWebhooksRoute: AdminGeneralWebhooksRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AssetsRouteRouteChildren {
  AssetsAddShipmentRoute: typeof AssetsAddShipmentRoute
  AssetsIndexRoute: typeof AssetsIndexRoute
}

const AssetsRouteRouteChildren: AssetsRouteRouteChildren = {
  AssetsAddShipmentRoute: AssetsAddShipmentRoute,
  AssetsIndexRoute: AssetsIndexRoute,
}

const AssetsRouteRouteWithChildren = AssetsRouteRoute._addFileChildren(
  AssetsRouteRouteChildren,
)

interface BigRentzLiftsRouteRouteChildren {
  BigRentzLiftsIndexRoute: typeof BigRentzLiftsIndexRoute
}

const BigRentzLiftsRouteRouteChildren: BigRentzLiftsRouteRouteChildren = {
  BigRentzLiftsIndexRoute: BigRentzLiftsIndexRoute,
}

const BigRentzLiftsRouteRouteWithChildren =
  BigRentzLiftsRouteRoute._addFileChildren(BigRentzLiftsRouteRouteChildren)

interface MeRouteRouteChildren {
  MeNotificationsAllRoute: typeof MeNotificationsAllRoute
  MeNotificationsManagedRoute: typeof MeNotificationsManagedRoute
  MeNotificationsPreferencesRoute: typeof MeNotificationsPreferencesRoute
}

const MeRouteRouteChildren: MeRouteRouteChildren = {
  MeNotificationsAllRoute: MeNotificationsAllRoute,
  MeNotificationsManagedRoute: MeNotificationsManagedRoute,
  MeNotificationsPreferencesRoute: MeNotificationsPreferencesRoute,
}

const MeRouteRouteWithChildren =
  MeRouteRoute._addFileChildren(MeRouteRouteChildren)

interface WorkOrdersRouteRouteChildren {
  WorkOrdersCreateWorkOrderRoute: typeof WorkOrdersCreateWorkOrderRoute
  WorkOrdersIndexRoute: typeof WorkOrdersIndexRoute
  WorkOrdersCreateBatchIdRoute: typeof WorkOrdersCreateBatchIdRoute
  WorkOrdersCreateIndexRoute: typeof WorkOrdersCreateIndexRoute
}

const WorkOrdersRouteRouteChildren: WorkOrdersRouteRouteChildren = {
  WorkOrdersCreateWorkOrderRoute: WorkOrdersCreateWorkOrderRoute,
  WorkOrdersIndexRoute: WorkOrdersIndexRoute,
  WorkOrdersCreateBatchIdRoute: WorkOrdersCreateBatchIdRoute,
  WorkOrdersCreateIndexRoute: WorkOrdersCreateIndexRoute,
}

const WorkOrdersRouteRouteWithChildren = WorkOrdersRouteRoute._addFileChildren(
  WorkOrdersRouteRouteChildren,
)

interface DataTemplatesRouteRouteChildren {
  DataTemplatesTemplateIdRoute: typeof DataTemplatesTemplateIdRoute
}

const DataTemplatesRouteRouteChildren: DataTemplatesRouteRouteChildren = {
  DataTemplatesTemplateIdRoute: DataTemplatesTemplateIdRoute,
}

const DataTemplatesRouteRouteWithChildren =
  DataTemplatesRouteRoute._addFileChildren(DataTemplatesRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AssetsRouteRoute: AssetsRouteRouteWithChildren,
  BigRentzLiftsRouteRoute: BigRentzLiftsRouteRouteWithChildren,
  MeRouteRoute: MeRouteRouteWithChildren,
  WorkOrdersRouteRoute: WorkOrdersRouteRouteWithChildren,
  TestRoute: TestRoute,
  DataTemplatesRouteRoute: DataTemplatesRouteRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
  AuthUnauthorizedRoute: AuthUnauthorizedRoute,
  DataClientsRoute: DataClientsRoute,
  DataCreateLocationsRoute: DataCreateLocationsRoute,
  DataProjectsRoute: DataProjectsRoute,
  NotificationActionRoute: NotificationActionRoute,
  DataIndexRoute: DataIndexRoute,
  DataLocationsIndexRoute: DataLocationsIndexRoute,
  FieldServicesSupportCasesIndexRoute: FieldServicesSupportCasesIndexRoute,
  FinanceSalesOrdersIndexRoute: FinanceSalesOrdersIndexRoute,
  DataLocationsCreateBatchIdRoute: DataLocationsCreateBatchIdRoute,
  DataLocationsCreateIndexRoute: DataLocationsCreateIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
